import { Link } from "react-router-dom";
import type { AnimeWork } from "@/types/anime";
import { useFavorites } from "@/hooks/useFavorites";

export default function WorkCard({ work }: { work: AnimeWork }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const favorited = isFavorite(work.id);

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
      <div className="relative h-64 w-full overflow-hidden bg-background-100">
        <Link to={`/recommendations/detail/${work.id}`} className="block h-full w-full cursor-pointer">
          <img
            src={work.cover}
            alt={`${work.title} 作品封面`}
            title={`${work.title} - 78动漫作品推荐`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <span className="absolute left-2.5 top-2.5 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs font-medium text-background-50">
          {work.type}
        </span>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-xs" />
          {work.score.toFixed(1)}
        </span>
        <button
          type="button"
          onClick={() => toggleFavorite(work.id)}
          aria-label={favorited ? "取消收藏" : "收藏作品"}
          className={`absolute bottom-2.5 right-2.5 flex h-9 w-9 items-center justify-center rounded-full transition-colors cursor-pointer ${
            favorited
              ? "bg-accent-500 text-background-50"
              : "bg-background-50/90 text-foreground-700 hover:bg-background-50 hover:text-accent-600"
          }`}
        >
          <i className={favorited ? "ri-heart-fill text-lg" : "ri-heart-line text-lg"} />
        </button>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          <Link to={`/recommendations/detail/${work.id}`} className="cursor-pointer">
            {work.title}
          </Link>
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
          <span>{work.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{work.region}</span>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}